import { Typography } from "@mui/material";
import React from "react";
export const FAQ = ({ answer, children, question }) => (React.createElement(React.Fragment, null,
    React.createElement(Typography, { component: "h2", variant: "h3" }, question),
    !!answer
        ? answer.map((p, ix) => (React.createElement(Typography, { key: `${question}-p-${ix}`, variant: "body1", paragraph: true }, p)))
        : children));
//# sourceMappingURL=faq.js.map